import { getProfile } from '../../backend-services';
import { AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js';
import { useState } from 'react';
import userPool from '../../utils/userPool';
import { useNavigate } from 'react-router-dom';
import {useUserStore} from "../../state/useUserStore";
import { STORAGE_TOKEN, STORAGE_REFRESH_TOKEN } from '../../constants';
import {inventoryService} from "../../services";


export const useCognitoLogin = () => {
  const { setUser } = useUserStore();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
 
  const authenticateUser = async (username: string, password:string) => {
    setIsLoading(true);
    const user = new CognitoUser({Username: username, Pool: userPool});
 
    const authenticationDetails = new AuthenticationDetails({
      Username: username,
      Password: password,
    });
 
    user.authenticateUser(authenticationDetails, {
      onSuccess: function (result) {
        setIsLoading(false);
        const token = result.getIdToken().getJwtToken();
        const refreshToken = result.getRefreshToken().getToken();
 
        // Set session storage items
        sessionStorage.setItem(STORAGE_TOKEN, token);
        sessionStorage.setItem(STORAGE_REFRESH_TOKEN, refreshToken);
        sessionStorage.setItem(username, user.getUsername());
 
        // Non-blocking profile retrieval
        getProfile().then(userData => {
          setUser(userData);
          if(!userData?.firstLogin) {
            navigate('/businessLayout');
            return;
          }
          navigate('/dashboard');
        }).catch(error => {
          console.error("Failed to retrieve user profile:", error);
        });
 
        navigate('/dashboard');
      },
 
      onFailure: function (err) {
        setIsLoading(false);
        setErrorMessage(err.message);
      },
      newPasswordRequired: function (userAtt, reqAtt) {
        console.log(userAtt);
        console.log(reqAtt);
      },
    });
  };
 
  return {
    authenticateUser,
    isLoading,
    errorMessage,
  };
}